export enum OfferLegalInfoListPositionEnum {
  SUBSCRIPTION = 'SUBSCRIPTION',
  INSTALLMENT = 'INSTALLMENT'
}

